import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { EmailListItem } from "./EmailListItem";

export function EmailList({ emails, selectedEmailId, onSelectEmail }) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredEmails = emails.filter(
    (e) =>
      e.subject.toLowerCase().includes(searchQuery.toLowerCase()) ||
      e.from.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div className="flex flex-col h-full border-r border-slate-200">
      {/* Search bar */}
      <div className="p-3 border-b border-slate-200 flex-shrink-0">
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <input
            type="text"
            placeholder="Search emails..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
          />
        </div>
      </div>

      {/* Count */}
      <div className="px-4 py-2 border-b border-slate-100 flex-shrink-0">
        <span className="text-xs font-medium text-slate-400">
          {filteredEmails.length} message{filteredEmails.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Email list */}
      <div className="flex-1 overflow-y-auto">
        {filteredEmails.length === 0 ? (
          <div className="flex items-center justify-center h-32">
            <p className="text-sm text-gray-400">No emails found</p>
          </div>
        ) : (
          filteredEmails.map((email) => (
            <EmailListItem
              key={email.id}
              email={email}
              isSelected={email.id === selectedEmailId}
              onClick={onSelectEmail}
            />
          ))
        )}
      </div>
    </div>
  );
}
